import React from 'react';
import { Range } from '../../../../domain/FilterTypes';
import { formatTimeOnMarketValue } from '../../../../domain/mappers/timeOnMarketMapper';

interface TimeOnMarketBodyProps {
  options: string[];
  value: Range;
  onChange: (value: string) => void;
}

export const TimeOnMarketBody = ({ options, value, onChange }: TimeOnMarketBodyProps) => {
  return (
    <div>
      <h3 className="font-semibold text-gray-900 mb-3">Time Posted</h3>
      <select
        value={formatTimeOnMarketValue(value, options)}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      >
        {options.map((option) => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>
    </div>
  );
};
